import { render } from "./moh204a.vue?vue&type=template&id=10c5ea41&scoped=true"
import script from "./moh204a.vue?vue&type=script&lang=js"
export * from "./moh204a.vue?vue&type=script&lang=js"

import "./moh204a.vue?vue&type=style&index=0&id=10c5ea41&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c5ea41"]])

export default __exports__